<script setup>
import { computed, useEventTracking } from '#imports';

const props = defineProps({
  articles: {
    type: Array,
    required: true,
  },
});

const preparedArticles = computed(() =>
  props.articles.map((item) => ({
    ...item,
    size: 'small',
    isFullImage: true,
    titleColor: '#ffffff',
    subtitleColor: '#0E0E0E',
    shadowColor: '#101010',
  }))
);
</script>

<template>
  <div class="more-articles">
    <div class="more-articles__grid">
      <div
        v-for="article in preparedArticles"
        :key="article._id"
        class="more-articles__grid-item"
      >
        <a
          v-if="article.isArticleExternalSourceType"
          :href="article.externalSource"
          target="_blank"
          @click="useEventTracking('click', 'Go to article from author page')"
        >
          <PostCardArticle
            :post="article"
            size="small"
            title-color="#ffffff"
            subtitle-color="#ffffff"
            shadow-color="#280045"
            :is-full-image="true"
          />
        </a>
        <NuxtLink
          v-else
          :to="{
            name: 'articles-slug',
            params: { slug: article.slug.current },
          }"
        >
          <PostCardArticle
            :post="article"
            size="small"
            title-color="#ffffff"
            subtitle-color="#ffffff"
            shadow-color="#280045"
            :is-full-image="true"
          />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.more-articles {
  padding-bottom: 32px;

  &__title {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 22px;
    color: rgba(var(--black-color--rgb), 40%);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: dense;
    gap: 24px;
  }

  &__grid-item {
    grid-column-end: span 1;
    grid-row-end: span 2;
  }

  @media (--large-vp) {
    &__grid {
      gap: 20px;
    }
  }

  @media (--small-vp) {
    padding-bottom: 60px;

    &__title {
      margin-bottom: 8px;
      padding-right: 6px;
      font-size: 14px;
      line-height: 20px;
    }

    &__grid {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
}
</style>
